import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

import { GlobalState } from 'ha/types/store';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    width: '100%',
    // 1300 is the z-index for the Google Map on search page
    // and we want this progress bar to be above that.
    zIndex: 1301,
  },
}));

export const ProgressBar: React.FC = () => {
  const isLoaded = useSelector(
    (state: GlobalState) => state.reduxAsyncConnect.loaded,
  );
  const classes = useStyles();

  if (isLoaded) {
    return null;
  }

  return (
    <div className={classes.root} data-test-locator="PageProgressBar">
      <LinearProgress />
    </div>
  );
};
